require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./label"), require("./tooltip"), require("./progressindicator"), require("./link"), require("./multilinetruncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./truncatedtext", "./label", "./tooltip", "./progressindicator", "./link", "./multilinetruncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./label"), require("./tooltip"), require("./progressindicator"), require("./link"), require("./multilinetruncatedtext")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./truncatedtext"], root["./label"], root["./tooltip"], root["./progressindicator"], root["./link"], root["./multilinetruncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__27__, __WEBPACK_EXTERNAL_MODULE__29__, __WEBPACK_EXTERNAL_MODULE__90__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[65],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = __webpack_require__(14);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

var _button = _interopRequireDefault(__webpack_require__(15));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _multilinetruncatedtext = _interopRequireDefault(__webpack_require__(90));

var _link = _interopRequireDefault(__webpack_require__(29));

var _label = _interopRequireDefault(__webpack_require__(19));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(64));

var _folder_ = _interopRequireDefault(__webpack_require__(89));

var _utils = __webpack_require__(4);

var _CarbonTile = _interopRequireDefault(__webpack_require__(537));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames,
    isKey = _utils.keyboardUtils.isKey;

var tileClassName = _CarbonTile["default"].tileClassName.replace(/"/g, '');

var CarbonTile = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CarbonTile, _Component);

  function CarbonTile() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hover: false,
      iconHover: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenu", function (e) {
      var onMenu = _this.props.onMenu;
      onMenu && onMenu(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onContextMenu", function (e) {
      var onMenu = _this.props.onMenu;
      e.stopPropagation();
      e.preventDefault();

      if (onMenu) {
        onMenu && onMenu(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClick", function (e) {
      e.stopPropagation();
      var onAction = _this.props.onAction;
      onAction && onAction(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTileSelect", function (e) {
      var onTileSelect = _this.props.onTileSelect;
      onTileSelect && onTileSelect(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      var F10 = keyNames.F10,
          ENTER = keyNames.ENTER,
          SPACE = keyNames.SPACE;

      switch (getKeyName(e)) {
        case F10:
          if (e.shiftKey) {
            e.preventDefault();

            _this._onMenu(e);
          }

          break;

        case ENTER:
          e.preventDefault();

          _this._onClick(e);

          break;

        case SPACE:
          e.preventDefault();

          _this._onTileSelect(e);

          break;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.setState({
        iconHover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function () {
      _this.setState({
        iconHover: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setHoverState", function (hover) {
      if (_this.hoverDebounce) {
        clearTimeout(_this.hoverDebounce);
        _this.hoverDebounce = null;
      }

      if (_this.state.hover !== hover) {
        _this.hoverDebounce = setTimeout(function () {
          _this.setState({
            hover: hover
          });

          _this.hoverDebounce = null;
        }, 100);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseEnter", function () {
      _this._setHoverState(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseLeave", function () {
      _this._setHoverState(false);
    });
    return _this;
  }

  var _proto = CarbonTile.prototype;

  _proto._menuRenderer = function _menuRenderer() {
    var ellipsisIcon = this.props.ellipsisIcon;
    var menu;
    menu = this.state.hover === true ? /*#__PURE__*/_react["default"].createElement("div", {
      className: tileClassName + "__header__title"
    }, ellipsisIcon || /*#__PURE__*/_react["default"].createElement(_button["default"], {
      tabIndex: -1,
      onMouseEnter: this._onFocus,
      onMouseLeave: this._onBlur,
      className: tileClassName + "__header__icon " + (this.state.iconHover ? '' : 'hover'),
      onClick: this._onMenu,
      onBlur: this._onMouseLeave,
      variant: "icon",
      size: "small",
      icon: _overflowMenuVertical_["default"].id,
      title: this.props.ellipsisTooltipLabel,
      "aria-label": this.props.ellipsisTooltipLabel,
      tooltipAlignment: "end"
    })) : null;
    return menu;
  };

  _proto._addLink = function _addLink(content, name) {
    var _this$props = this.props,
        onMenu = _this$props.onMenu,
        onAction = _this$props.onAction,
        container = _this$props.container;
    return /*#__PURE__*/_react["default"].createElement(_link["default"], {
      style: {
        cursor: 'default',
        width: '80%'
      },
      onContextMenu: this._onContextMenu,
      disabled: content.disabled
    }, container ? name : /*#__PURE__*/_react["default"].createElement("div", {
      onClick: onAction ? this._onClick : null,
      tabIndex: -1
    }, name));
  };

  _proto.focus = function focus() {
    var tileNode = (0, _reactDom.findDOMNode)(this).nextSibling;

    if (tileNode) {
      tileNode.focus();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        container = _this$props2.container,
        content = _this$props2.content,
        className = _this$props2.className,
        selected = _this$props2.selected,
        onMenu = _this$props2.onMenu,
        ellipsisIcon = _this$props2.ellipsisIcon,
        size = _this$props2.size,
        dateLabel = _this$props2.dateLabel,
        onAction = _this$props2.onAction,
        onTileSelect = _this$props2.onTileSelect,
        light = _this$props2.light,
        tabIndex = _this$props2.tabIndex;
    var hover = this.state.hover;
    var classNames = (0, _utils.classnames)(tileClassName, size, {
      selected: selected,
      container: container,
      hover: hover && !!onMenu
    });
    var props = {
      selected: selected,
      handleClick: onTileSelect ? this._onTileSelect : null,
      handleKeyDown: this.handleKeyDown,
      onContextMenu: this._onContextMenu,
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      onFocus: this._onMouseEnter,
      onBlur: this._onMouseLeave,
      light: light,
      tabIndex: tabIndex === undefined ? 0 : tabIndex,
      className: classNames + " " + className
    };

    if (container) {
      var containerName = /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
        className: tileClassName + "__body__col__label " + (content.disabled ? 'disabled' : ''),
        tooltipDelay: true,
        tabIndex: -1,
        onClick: onAction ? this._onClick : null,
        title: content.label,
        value: content.label,
        location: 'end',
        disabled: content.disabled
      });

      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectableTile, props, /*#__PURE__*/_react["default"].createElement("div", {
        className: tileClassName + "__folder__content"
      }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Row, {
        className: tileClassName + "__body"
      }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Column, {
        className: tileClassName + "__body__col"
      }, content.readOnly || content.disabled ? containerName : this._addLink(content, containerName), hover ? (onMenu || ellipsisIcon) && this._menuRenderer() : null)), /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Row, {
        className: tileClassName + "__folder"
      }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Column, {
        style: {
          display: 'inline-flex'
        }
      }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
        label: dateLabel,
        disabled: content.disabled,
        "aria-label": dateLabel,
        className: tileClassName + "__folder__label"
      }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
        label: content.date,
        disabled: content.disabled,
        "aria-label": content.disabled,
        className: tileClassName + "__folder__date"
      })), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        title: content.type,
        orient: "top",
        style: {
          marginTop: 'auto'
        }
      }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        className: tileClassName + "__folder__icon " + content.color,
        iconId: content.iconId ? content.iconId : _folder_["default"].id,
        title: content.type,
        disabled: content.disabled
      })))));
    }

    var assetName = /*#__PURE__*/_react["default"].createElement(_multilinetruncatedtext["default"], {
      className: tileClassName + "__body__col__label " + (content.disabled ? 'disabled' : '') + " " + (content.sub_label ? 'has-sublabel' : ''),
      tooltipDelay: true,
      title: content.label,
      style: {
        width: '100%',
        whiteSpace: 'nowrap'
      },
      value: content.label,
      numLines: content.sub_label ? 2 : 3,
      disabled: content.disabled
    });

    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectableTile, props, /*#__PURE__*/_react["default"].createElement("div", {
      className: tileClassName + "__content"
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Row, {
      className: tileClassName + "__body"
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Column, {
      className: tileClassName + "__body__col"
    }, content.readOnly || content.disabled ? assetName : this._addLink(content, assetName), hover ? (onMenu || ellipsisIcon) && this._menuRenderer() : null)), content.sub_label ? /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Row, {
      className: tileClassName + "__sublabel"
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Column, null, /*#__PURE__*/_react["default"].createElement(_multilinetruncatedtext["default"], {
      className: tileClassName + "__sublabel__text",
      tooltipDelay: true,
      title: content.sub_label,
      style: {
        width: '100%',
        whiteSpace: 'nowrap',
        maxWidth: '100%'
      },
      value: content.sub_label,
      numLines: 2,
      disabled: content.disabled
    }))) : null, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Row, {
      className: tileClassName + "__footer"
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Column, null, /*#__PURE__*/_react["default"].createElement(_label["default"], {
      label: dateLabel,
      disabled: content.disabled,
      "aria-label": dateLabel,
      className: tileClassName + "__footer__label"
    }), /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      className: tileClassName + "__footer__date",
      tooltipDelay: true,
      title: content.date,
      width: '100%',
      value: content.date,
      disabled: content.disabled
    })), content.showTag === true ? /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Tag, {
      type: content.color,
      className: tileClassName + "__footer__tag",
      disabled: content.disabled || content.hidden
    }, content.type) : null, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      title: content.type,
      orient: "top"
    }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      className: tileClassName + "__footer__icon " + content.color,
      iconId: content.iconId ? content.iconId : _folder_["default"].id,
      title: content.type,
      size: "normal",
      disabled: content.disabled
    })))));
  };

  return CarbonTile;
}(_react.Component);

exports["default"] = CarbonTile;
(0, _defineProperty2["default"])(CarbonTile, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Select folder or asset tile */
  container: _propTypes["default"].bool,

  /** Flag to select the tile */
  selected: _propTypes["default"].bool,

  /** Data passed to tile */
  content: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    iconId: _propTypes["default"].string,
    label: _propTypes["default"].string,
    sub_label: _propTypes["default"].string,
    date: _propTypes["default"].string,
    showTag: _propTypes["default"].bool,
    value: _propTypes["default"].any,
    disabled: _propTypes["default"].bool,
    hidden: _propTypes["default"].bool
  }).isRequired,

  /** Callback function for context menu */
  onMenu: _propTypes["default"].func,
  onAction: _propTypes["default"].func,
  onTileSelect: _propTypes["default"].func,

  /** Svg icon when loading context menu */
  ellipsisIcon: _propTypes["default"].element,

  /** ellipsisIcon toop string */
  ellipsisTooltipLabel: _propTypes["default"].string,

  /** Data Label to display in footer */
  dateLabel: _propTypes["default"].string,

  /** boolean to specify tile background color  */
  light: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].number
});
(0, _defineProperty2["default"])(CarbonTile, "defaultProps", {
  size: 'small',
  container: false,
  selected: false,
  className: '',
  ellipsisTooltipLabel: 'Action menu',
  dateLabel: 'Last modified'
});

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__27__;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(535);


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TileView = _interopRequireDefault(__webpack_require__(536));

exports["default"] = _TileView["default"];
exports.TileView = _TileView["default"];

var _CarbonTile = _interopRequireDefault(__webpack_require__(126));

exports.CarbonTile = _CarbonTile["default"];

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _progressindicator = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(4);

var _CarbonTile = _interopRequireDefault(__webpack_require__(126));

var _TileView = _interopRequireDefault(__webpack_require__(539));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames,
    isKey = _utils.keyboardUtils.isKey;

var tileViewClassName = _TileView["default"].tileViewClassName.replace(/"/g, '');

var TileView = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TileView, _Component);

  function TileView(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      tilesGroup: [],
      loaded: false,
      active: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var LEFT = keyNames.LEFT,
          RIGHT = keyNames.RIGHT,
          HOME = keyNames.HOME,
          UP = keyNames.UP,
          END = keyNames.END,
          DOWN = keyNames.DOWN;
      var active = _this.state.active;
      var length = _this.tileRefs.length;
      var i = active;

      switch (getKeyName(e)) {
        case HOME:
        case UP:
        case LEFT:
          e.preventDefault();

          if (e.altKey || isKey(e, HOME)) {
            if (i === 0) {
              return;
            }

            i = 0;
          } else if (i === -1) {
            i = length - 1;
          } else if (i <= 0) {
            return;
          } else {
            i -= 1;
          }

          break;

        case END:
        case DOWN:
        case RIGHT:
          e.preventDefault();

          if (e.altKey || isKey(e, END)) {
            if (i === length - 1) {
              return;
            }

            i = length - 1;
          } else if (i === -1) {
            i = 0;
          } else if (i >= length - 1) {
            return;
          } else {
            i += 1;
          }

          break;
      }

      if (i !== active) {
        _this.focus(i);

        _this.setState({
          active: i
        });
      }
    });
    _this.tileRefs = [];
    return _this;
  }

  var _proto = TileView.prototype;

  _proto._tileRef = function _tileRef(index, ref) {
    this.tileRefs[index] = ref;
  };

  _proto.focus = function focus(index) {
    var active = this.state.active;
    var i = index === undefined ? active : index;
    this.tileRefs[i].focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        tilesGroup = _this$props.tilesGroup,
        loaded = _this$props.loaded,
        container = _this$props.container,
        light = _this$props.light;
    var active = this.state.active;
    var index = 0;
    var tiles;
    loaded && tilesGroup && tilesGroup.length > 0 && tilesGroup.forEach(function (group) {
      if (group.tiles.length > 0) {
        tiles = group.tiles.map(function (tile) {
          var i = index++;
          return /*#__PURE__*/_react["default"].createElement(_CarbonTile["default"], {
            className: tileViewClassName + "__tile",
            container: container,
            key: tile.label,
            selected: tile.selected,
            content: tile,
            onMenu: tile.onMenu ? function (e) {
              tile.onMenu(e, tile.id);
            } : null,
            ellipsisIcon: tile.ellipsisIcon,
            ellipsisTooltipLabel: tile.ellipsisTooltipLabel,
            onAction: function onAction(e) {
              tile.openTile(e, tile.id);
            },
            onTileSelect: function onTileSelect(e) {
              tile.onSelect(e, tile.id);
            },
            dateLabel: tile.dateLabel,
            light: light,
            tabIndex: active === i ? 0 : -1,
            ref: function ref(_ref) {
              _this2._tileRef(i, _ref);
            }
          });
        });
      }
    });
    return loaded ? /*#__PURE__*/_react["default"].createElement("div", {
      className: tileViewClassName + " " + className,
      onKeyDown: this._onKeyDown
    }, tiles ? /*#__PURE__*/_react["default"].createElement("div", {
      className: tileViewClassName + "__asset"
    }, tiles) : null) : /*#__PURE__*/_react["default"].createElement("div", {
      className: tileViewClassName + "__loading"
    }, /*#__PURE__*/_react["default"].createElement(_progressindicator["default"], {
      size: "large",
      variant: "circle"
    }));
  };

  return TileView;
}(_react.Component);

exports["default"] = TileView;
(0, _defineProperty2["default"])(TileView, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** A list of the tiles formatted properly for use from the ca-ui-toolkit */
  tilesGroup: _propTypes["default"].array,

  /** boolean to display progress indicator  */
  loaded: _propTypes["default"].bool,

  /** boolean to specify folder or asset  */
  container: _propTypes["default"].bool,

  /** boolean to specify tile background color  */
  light: _propTypes["default"].bool
});

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-tile .ba-tile__content .ba-tile__body__col__label,.ba-tile .ba-tile__content .ba-tile__body__sublabel,.ba-tile .ba-tile__content .ba-tile__sublabel__text,.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label{font-size:1rem;font-weight:400;line-height:1.25rem}.ba-tile .ba-tile__content .ba-tile__footer__label,.ba-tile .ba-tile__content .ba-tile__footer__date,.ba-tile .ba-tile__content .ba-tile__footer__tag,.ba-tile.is-container .ba-tile__header,.ba-tile.is-container .ba-tile__folder__label,.ba-tile.is-container .ba-tile__folder__date{font-size:.75rem;font-weight:400;line-height:1rem}.ba-tile{height:180px;padding:8px 8px 16px 16px !important;cursor:default}.ba-tile.is-selected{outline-color:#161616;outline-color:hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);outline:1px solid;outline-offset:-1px}.ba-tile.is-selected .bx--tile__checkmark{opacity:1}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.ba-tile{width:320px}}.ba-tile .ba-tile__content{display:flex;flex-direction:column;justify-content:space-between;height:inherit}.ba-tile .ba-tile__content .ba-tile__header{color:#595859}.ba-tile .ba-tile__content .ba-tile__header__icon{background-color:rgba(0,0,0,0)}.ba-tile .ba-tile__content .ba-tile__header__icon.hover::before{display:none}.ba-tile .ba-tile__content .ba-tile__header__icon.hover span.bx--assistive-text{display:none}.ba-tile .ba-tile__content .ba-tile__header svg.contextMenuButton{padding-top:0px !important}.ba-tile .ba-tile__content .ba-tile__body{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);margin-right:0%}.ba-tile .ba-tile__content .ba-tile__body__col{display:flex;justify-content:space-between;padding-right:0px}.ba-tile .ba-tile__content .ba-tile__body__col__label{padding-top:8px;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;cursor:pointer}.ba-tile .ba-tile__content .ba-tile__body__col__label.disabled{pointer-events:none;cursor:not-allowed}.ba-tile .ba-tile__content .ba-tile__body__col__label .ba-common-tooltip>div{display:table;border-bottom:1px solid transparent}.ba-tile .ba-tile__content .ba-tile__body__col__label:hover .ba-common-tooltip>div{display:table;border-bottom:1px solid;border-color:#0353e9}.ba-tile .ba-tile__content .ba-tile__body__sublabel{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;max-width:100%}.ba-tile .ba-tile__content .ba-tile__sublabel{margin-right:1rem}.ba-tile .ba-tile__content .ba-tile__sublabel__text{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;max-width:100%}.ba-tile .ba-tile__content .ba-tile__footer{font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;color:black;margin-right:0%;margin-top:auto}.ba-tile .ba-tile__content .ba-tile__footer__label{margin-right:auto;color:#595859}.ba-tile .ba-tile__content .ba-tile__footer__date{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1)}.ba-tile .ba-tile__content .ba-tile__footer__tag{height:12px;color:#595859}.ba-tile .ba-tile__content .ba-tile__footer__icon{padding-top:8px;padding-right:4px;fill:#161616}.ba-tile .ba-tile__content .ba-tile__footer__icon.purple{fill:#a56eff}.ba-tile .ba-tile__content .ba-tile__footer__icon.blue{fill:#4589ff}.ba-tile .ba-tile__content .ba-tile__footer__icon.teal{fill:#009d9a}.ba-tile .ba-tile__content .ba-common-tags__list{align-items:flex-end}.ba-tile:focus{outline:2px solid #0353e9;outline-offset:-2px;background-color:#e5e5e5}.ba-tile.is-container{height:90px;padding:8px 8px 16px 16px !important;cursor:default}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.ba-tile.is-container{width:320px}}.ba-tile.is-container .ba-tile__folder__content{display:flex;flex-direction:column;justify-content:space-between;height:inherit}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);margin-right:0%}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col{display:flex;justify-content:space-between;padding-right:0px}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col>a:hover{text-decoration:none}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label{padding-top:8px;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;margin-bottom:8px;max-width:100%;border-bottom:1px solid transparent}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label.disabled{pointer-events:none;cursor:not-allowed}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label .ba-common-tooltip>div{cursor:pointer}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label:hover{border-bottom:1px solid;border-color:#0353e9}.ba-tile.is-container .ba-tile__header{color:#595859}.ba-tile.is-container .ba-tile__header__icon{background-color:rgba(0,0,0,0)}.ba-tile.is-container .ba-tile__header__icon.hover::before{display:none}.ba-tile.is-container .ba-tile__header__icon.hover span.bx--assistive-text{display:none}.ba-tile.is-container .ba-tile__header svg.contextMenuButton{padding-top:0px !important}.ba-tile.is-container .ba-tile__folder{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;margin-top:auto;margin-right:0%}.ba-tile.is-container .ba-tile__folder__label{color:#595859;margin-top:auto;display:flex}.ba-tile.is-container .ba-tile__folder__date{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);margin-top:auto;margin-left:4px}.ba-tile.is-container .ba-tile__folder__icon{margin-top:auto;padding-top:8px;padding-right:4px;fill:#161616}.ba-tile.is-container .ba-tile__folder__icon.purple{fill:#a56eff}.ba-tile.is-container .ba-tile__folder__icon.blue{fill:#4589ff}.ba-tile.is-container .ba-tile__folder__icon.teal{fill:#009d9a}.ba-tile.is-container:focus{outline:2px solid #0353e9;outline-offset:-2px;background-color:#e5e5e5}\n", ""]);

// exports
exports.locals = {
	"tileClassName": "\"ba-tile\""
};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-tileView__asset{margin-bottom:1rem;height:auto;width:100%;display:grid;grid-template-columns:repeat(auto-fill, minmax(290px, 1fr));grid-template-rows:auto;grid-gap:1rem}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.ba-tileView__asset{display:-ms-flexbox;flex-direction:row;-ms-flex-direction:row;flex-wrap:wrap;-ms-flex-wrap:wrap}.ba-tileView__tile{margin-right:16px;margin-bottom:16px}}.ba-tileView__loading{position:fixed;top:50%;left:50%;display:flex;justify-content:center;align-items:center}\n", ""]);

// exports
exports.locals = {
	"tileViewClassName": "\"ba-tileView\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js");

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/folder_32");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__90__;

/***/ })

},[[534,0]]]);
});